import {h} from 'preact';
import { useState } from 'preact/hooks';
import { Button, Typography, message, Tooltip } from 'antd';
import { CopyOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const PasswordField = ({ password }) => {
    const [showPassword, setShowPassword] = useState(false);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(password);
            message.success('Password copied to clipboard');
        } catch (err) {
            message.error('Failed to copy password');
        }
    };

    return (
        <div>
            <Text strong style={{
                display: "block",
                marginBottom: 8,
                fontSize: "14px",
                color: "#666",
                textTransform: "uppercase"
            }}>
                Temporary Password
            </Text>
            <div style={{
                backgroundColor: "#fafafa",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #f0f0f0",
                fontSize: "16px",
                fontFamily: "monospace",
                wordBreak: "break-all",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <span>
                    {password
                        ? (showPassword
                                ? password
                                : '•'.repeat(Math.min(password.length, 12))
                        )
                        : "User has no temporary password"
                    }
                </span>
                {password && (
                    <div style={{display: "flex", gap: 4, marginLeft: 8}}>
                        <Tooltip title="Copy password">
                            <Button
                                type="text"
                                size="small"
                                icon={<CopyOutlined />}
                                onClick={copyToClipboard}
                            />
                        </Tooltip>
                        <Tooltip title={showPassword ? "Hide password" : "Show password"}>
                            <Button
                                type="text"
                                size="small"
                                icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PasswordField;